if (!window.vrpAutoplayVideo) {
  window.vrpAutoplayVideo = true;

  const PAUSE_LABEL = 'Pause video';
  const PLAY_LABEL = 'Play video';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function labelsFor(host) {
    const source = host?.closest('[data-pause-label]') || host;
    return {
      pause: source?.dataset.pauseLabel || PAUSE_LABEL,
      play: source?.dataset.playLabel || PLAY_LABEL
    };
  }

  function setControlState(button, video, host) {
    const labels = labelsFor(host);
    const paused = video.paused;
    button.setAttribute('aria-pressed', paused ? 'false' : 'true');
    button.setAttribute('aria-label', paused ? labels.play : labels.pause);
  }

  function visibleVideo(host) {
    const videos = [...host.querySelectorAll('video-media[autoplay] video')];
    return videos.find((video) => video.getClientRects().length > 0) || videos[0];
  }

  function createControl(host) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'vrp-video-control';
    button.innerHTML =
      '<span class="vrp-video-control__icon vrp-video-control__icon--pause" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><rect x="4.5" y="3.5" width="3.5" height="13" rx="0.75" fill="currentColor"/><rect x="12" y="3.5" width="3.5" height="13" rx="0.75" fill="currentColor"/></svg></span><span class="vrp-video-control__icon vrp-video-control__icon--play" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M6.5 4.2v11.6c0 .8.9 1.3 1.6.9l8.7-5.1c.7-.4.7-1.4 0-1.8l-8.7-5.1c-.7-.4-1.6 0-1.6.9Z" fill="currentColor"/></svg></span>';

    button.addEventListener('click', () => {
      const video = visibleVideo(host);
      button.dataset.pressed = '';

      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    return button;
  }

  function enhanceAutoplayVideo(media) {
    const video = media.querySelector('video');
    if (!video || 'vrpAutoplay' in video.dataset) {
      return;
    }

    video.dataset.vrpAutoplay = '';

    video.controls = false;
    video.setAttribute('playsinline', '');

    const host =
      media.closest('.vrp-autoplay-video') ||
      media.closest('.series-story__entry--hero') ||
      media.closest('.content-over-media');

    if (!host) {
      return;
    }

    host.classList.add('vrp-autoplay-video');
    const button = host.querySelector('.vrp-video-control') || host.appendChild(createControl(host));

    const holdForReducedMotion = () => {
      if (reducedMotion.matches && !('pressed' in button.dataset)) {
        video.pause();
      }
    };

    video.addEventListener('play', () => {
      holdForReducedMotion();
      setControlState(button, video, host);
    });
    video.addEventListener('pause', () => setControlState(button, video, host));

    if (!video.paused) {
      holdForReducedMotion();
    }

    setControlState(button, visibleVideo(host), host);
  }

  function initAutoplayVideoControls(root = document) {
    root.querySelectorAll('video-media[autoplay]').forEach(enhanceAutoplayVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAutoplayVideoControls());
  } else {
    initAutoplayVideoControls();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAutoplayVideoControls(event.target);
  });
  document.addEventListener('media:ready', (event) => {
    if (event.target.matches('video-media[autoplay]')) enhanceAutoplayVideo(event.target);
  });
}
